module.exports = __webpack_public_path__ + "static/flags/ST-cb6d86dc2b77055a9cae9344c388f094.gif";